import ApiConstants from '../constants/ApiConstants';
import Utility, { deepClone } from '../utility/Utility';
import http from "../http";
import { COLUMN_CODES, COMPLIANCE_TOOLTIP_FIELDS_MESSAGES, COMPLIANCE_UPDATED_FIELDS, CONSTANTS, COUNTRY_CODE, ERRORS_COMPONENTS, INPUT_FIELD_MAP, INPUT_FIELD_MAP_COMPLIANCE, INPUT_TYPE, US_ADMIN_COMPAINCE_FIELDS } from '../constants/Constant';
import moment, { invalid } from "moment";
import { AccountTypes, CompensationPeriod, CompensationPeriodUS, Countries, EmployeeTypes, Genders, IN_STATES, MaritalStatus, PaymentMethods } from '../components/add-employee/steps/Employee';
import { getCountryPhoneCode, getMaskedValue, isInCompliance, isIndiaCompliance, isUSCompliance, reverseTimezoneOffset } from '../managers/common/CommonUtil';
import { COMPONENT_FREQUENCY_TYPE_LIST, IN_CONFIGURE_AMOUNT_BASED_ON } from "../components/Component/ComponentConstants"
import DataGridUtility from '../utility/DataGridUtility';
import { TENANT, TenantService } from '../managers/TenantManagerService';
import { isMobileWebView } from '../utility/ViewportSizeUtils';
import { Nationalities } from '../constants/CountryConstant';

export interface EmployeeListAPIConfig {
    // SearchTerm?: string;
    Limit?: number;
    query?:string;
    sort?:string;
    currentPage?:string;
    order? :string;
    CurrentPage?: number;
    field?:string;
    searchField?:string;
    searchString?:string;
    isInCompleteProfile?:string;
    getComponents?: string;
    getCompliance?: string;
    getBenefits?: string;
    customFieldModule?: string;
    customJson?:string;
    userType?:string
}

const defaultConfig: EmployeeListAPIConfig = {
    Limit: 20,
    currentPage: '1',
    sort: 'clockIn',
    order: 'desc',
    field: `_id`,
    searchField: ``,
    searchString: ``,
    getComponents: ``,
    getCompliance: ``,
    getBenefits: ``,
    customFieldModule:``,
    userType:``

};

class EmployeeListService {
    static apiConfig: EmployeeListAPIConfig;

    static employeeStepperCurrentStep = 0;
    static filterArray;

    static getEmployeeByPage() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }

        let params = `&includeDraft=true&ignTeamData=true&isInCompleteProfile=${!!this.apiConfig.isInCompleteProfile}`;

        if (this.apiConfig.field) {
            params += `&field=${this.apiConfig.field}`;
        }

        if (this.apiConfig.order) {
            params += `&order=${this.apiConfig.order}`;
        }

        if (this.apiConfig.searchField) {
            params += `&searchField=${this.apiConfig.searchField}`;
        }

        if (this.apiConfig.searchString) {
            params += `&searchString=${this.apiConfig.searchString}`;
        }

        if (this.apiConfig.customJson && typeof this.apiConfig.customJson === 'object') {
            Object.keys(this.apiConfig.customJson).forEach(key => {
                params += `&${[key]}=${this.apiConfig.customJson[key]}`
            });
        }

        return http.get(`${ApiConstants.URL.BASE+ApiConstants.URL.PAYROLL.GET_USERS}\?limit=${this.apiConfig.Limit}&currentPage=${this.apiConfig.currentPage}` + params).catch(
            (error: any) => {
                console.error('Error loading payrolls: ', error);
                return Promise.reject(error);
            }
        );
    }

    static getFilterEmployee() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        let params = this.apiConfig.isInCompleteProfile ? `&isInCompleteProfile=${this.apiConfig.isInCompleteProfile}`:'';
        params += "&includeDraft=true&ignTeamData=true";
        let url = ApiConstants.URL.BASE+ApiConstants.URL.PAYROLL.FILTER_USER
        let paramStr = `&order=${this.apiConfig.order}&field=${this.apiConfig.field}`

        return http.post(
            `${url}\?limit=${this.apiConfig.Limit}&currentPage=${this.apiConfig.currentPage}`+ params + paramStr
            ,this.filterArray);
    }
    static getIncompleteUsers(){
        const url = ApiConstants.URL.BASE+ApiConstants.URL.PAYROLL.GET_USERS;
        const params =`&isInCompleteProfile=true&ignTeamData=true`;
        return http
            .get(
                `${url}\?limit=20&currentPage=1&order=${this.apiConfig.order}&field=${this.apiConfig.field}&searchField=&searchString=`+ params
            )
            .catch((err: any) => {
                console.error('Error loading payrolls: ', err);
                return Promise.reject(err);
            });
    }

    static getEmployeesWithoutPage() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        const url = ApiConstants.URL.BASE+ApiConstants.URL.PAYROLL.GET_USERS;
        let params = "&includeDraft=false&ignTeamData=true";
        let paramStr = '';
        if(this.apiConfig.customJson){
            let keys = Object.keys(this.apiConfig.customJson);
            keys.forEach(key=>{
                paramStr = paramStr + `&${[key]}=${this.apiConfig.customJson[key]}`
            })
        } else {
            paramStr = `&order=${this.apiConfig.order||''}&field=${this.apiConfig.field||''}&searchField=${this.apiConfig.searchField||''}&searchString=${this.apiConfig.searchString||''}`
        }
        return http
            .get(
                `${url}\?`+ params + paramStr
            )
            .catch((err: any) => {
                console.error('Error loading payrolls: ', err);
                return Promise.reject(err);
            });
    }

    static getContractorByPage() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        const url = ApiConstants.URL.BASE+ApiConstants.URL.PAYROLL.GET_USERS;
        let params = this.apiConfig.isInCompleteProfile ? `&isInCompleteProfile=${this.apiConfig.isInCompleteProfile}`:'';
        params += "&ignTeamData=true";
        let paramStr = '';
        if(this.apiConfig.customJson){
            let keys = Object.keys(this.apiConfig.customJson);
            keys.forEach(key=>{
                paramStr = paramStr + `&${[key]}=${this.apiConfig.customJson[key]}`
            })
        } else {
            paramStr = `&order=${this.apiConfig.order}&field=${this.apiConfig.field}&searchField=${this.apiConfig.searchField}&searchString=${this.apiConfig.searchString}&userType=${this.apiConfig.userType}`
        }
        return http
            .get(
                `${url}\?limit=${this.apiConfig.Limit}&currentPage=${this.apiConfig.currentPage}`+ params + paramStr
            )
            .catch((err: any) => {
                console.error('Error loading payrolls: ', err);
                return Promise.reject(err);
            });
    }

    static getHolidays() {
        const url = ApiConstants.URL.EMPLOYEE.GET_HOLIDAYS;
        return http.get(
            `${url}\?limit=50`
        )
    }

    static getEmployeeMeta(countryCode) {
        const url = ApiConstants.URL.EMPLOYEE.GET_EMPLOYEE_META(countryCode);
        return http.get(url);
    }

    static getTenantData(countryCode) {
        const url = ApiConstants.URL.PEOPLE.TENANT;
        return http.get(url);
    }

    static getEmployeeDetails(userId) {
        const url = ApiConstants.URL.EMPLOYEE.GET_DETAILS(userId);
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        return http.get(`${url}\?getComponents=${this.apiConfig.getComponents}&getCompliance=${this.apiConfig.getCompliance}&getBenefits=${this.apiConfig.getBenefits}&customFieldModule=${this.apiConfig.customFieldModule}`);
    }
    static getEmployeeDetailsDefault(userId) {
        const url = ApiConstants.URL.EMPLOYEE.GET_DETAILS(userId);
        return http.get(url+'?getComponents=true&getCompliance=true&getBenefits=true');
    }

    static getEmployeeTaxDetails(params) {
        const url = ApiConstants.URL.EMPLOYEE.GET_TAX_DETAILS(params.countryCode);
        return http.post(`${url}`, params.userIds);
    }
    static getUserDetailsByIamUserId(userId) {
        return http.get(`${ApiConstants.URL.BASE + ApiConstants.URL.USER.USER_BY_IAM(userId)}`)
    }
    static getContractorsList() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        const url = ApiConstants.URL.BASE+ApiConstants.URL.PAYROLL.GET_USERS;
        let params = this.apiConfig.isInCompleteProfile ? `&isInCompleteProfile=${this.apiConfig.isInCompleteProfile}`:'';
        params += "&ignTeamData=true";
        let paramStr = '';
        if(this.apiConfig.customJson){
            let keys = Object.keys(this.apiConfig.customJson);
            keys.forEach(key=>{
                paramStr = paramStr + `&${[key]}=${this.apiConfig.customJson[key]}`
            })
        } else {
            paramStr = `&order=${this.apiConfig.order}&field=${this.apiConfig.field}&searchField=${this.apiConfig.searchField}&searchString=${this.apiConfig.searchString}&userType=${this.apiConfig.userType}`
        }
        return http
            .get(
                `${url}\?limit=${this.apiConfig.Limit}&currentPage=${this.apiConfig.currentPage}`+ params + paramStr
            )
            .catch((err: any) => {
                console.error('Error loading payrolls: ', err);
                return Promise.reject(err);
            });
    }
    static getBankDetails(countryCode) {
        const url = ApiConstants.URL.EMPLOYEE.GET_BANK_DETAILS(countryCode);
        return http.get(url);
    }
    static getCPFAAccounts() {
        const url = ApiConstants.URL.EMPLOYEE.GET_CPF_ACCOUNTS;
        return http.get(
          `${url}\?limit=${this.apiConfig.Limit}&currentPage=${this.apiConfig.currentPage}&order=${this.apiConfig.order}&field=${this.apiConfig.field}&searchString=${this.apiConfig.searchString}`
        );
    }

    static createCustomFieldArray(fields, defaultValues, keysArray) {
        let fieldsArray = [];
        fields && fields.forEach(element => {
            let fields = {};
            let index = 0;
            fields['columnCode'] = element.id;
            fields['editable'] = true;
            fields['id'] = element.id;
            fields['index'] = index++;
            fields['name'] = element.name;
            fields['options'] = element.possibleValues;
            fields['required'] = element.isMandatory;
            fields['systemField'] = true;
            fields['type'] = INPUT_FIELD_MAP[element.type];
            fields['uiVisible'] = true;
            fields['width'] = 50;
            fields['direction'] = "VERTICAL";
            fields['readonly'] = false;
            fields['hasError'] = false;
            fields['errMsg'] = `Enter a valid ${element.name}`;
            fields['maxLength'] = element.maxLength;
            fields['decimalPrecision'] = element.decimalPrecision;
            defaultValues[element.id] = this.getDefaultDropDownValue(element);
            keysArray.push(fields["columnCode"]);
            fieldsArray.push(fields)
        });
        return fieldsArray;
    }

    static getDefaultDropDownValue(element) {
        let value = [];
        if(element && INPUT_FIELD_MAP[element.type] === INPUT_TYPE.MULTI_SELECT) {
            let options = element.possibleValues;
            let key = element.defaultValue.map(r => options.findIndex(x=> x === r));
            value = key
        } else {
            value = element.defaultValue[0];
        }
        return value;
    }

    static assignEmployeeDetails(defaultValues, userObject, customFields, bankAccounts) {
        defaultValues["firstName"]= userObject["firstName"];
        defaultValues["lastName"]= userObject["lastName"];
        defaultValues["employeeId"]= userObject["employeeId"];
        defaultValues["aliasName"]= userObject["aliasName"];
        defaultValues["emailId"]= userObject["emailId"];
        defaultValues["contact"]= ((userObject["contact"] != "" && userObject["contact"].includes(getCountryPhoneCode())) ? userObject["contact"].replace(getCountryPhoneCode(),"") : userObject["contact"] );
        defaultValues["designation"]= userObject["designation"];
        defaultValues["dateOfBirth"]= userObject["dateOfBirth"] ? reverseTimezoneOffset(userObject["dateOfBirth"]) : Utility.STRING_EMPTY;
        defaultValues["dateOfJoining"]= userObject["dateOfJoining"] ? reverseTimezoneOffset(userObject["dateOfJoining"]) : Utility.STRING_EMPTY;
        defaultValues["dateOfConfirmation"]= userObject["dateOfConfirmation"] ? reverseTimezoneOffset(userObject["dateOfConfirmation"]) : Utility.STRING_EMPTY;
        defaultValues["gender"]= this.getValueObjectFromDropdown(userObject["gender"], Genders, "id");
        defaultValues["maritalStatus"]= this.getValueObjectFromDropdown(userObject["maritalStatus"], MaritalStatus, "id");
        defaultValues["passportNumber"]= userObject["passportNumber"];
        defaultValues["passportCountry"]= this.getValueObjectFromDropdown(userObject["passportCountry"],Countries, "code");
        this.setAddressFields(defaultValues, userObject["address"]);
        defaultValues["employeeType"]= this.getValueObjectFromDropdown(userObject["employeeType"],EmployeeTypes, "id");
        defaultValues["ctc"]= isIndiaCompliance() ? (userObject["ctc"]).toString() :defaultValues["compensation"]= (userObject["compensation"]).toString();
        defaultValues["hourlyWageDefaultHrs"] = userObject?.hourlyWageDefaultHrs;
        const mappedCompensationPeriod = this.mapCompensationPeriodToDropdownId(userObject["compensationPeriod"]);
        defaultValues["period"]= isUSCompliance() ? this.getValueObjectFromDropdown(mappedCompensationPeriod,CompensationPeriodUS, "id"):this.getValueObjectFromDropdown(mappedCompensationPeriod,CompensationPeriod, "id");
        this.setPaymentFields(defaultValues, userObject["paymentDetails"], bankAccounts);
        this.setCustomFieldValues(defaultValues, userObject, customFields);
        defaultValues["isEffectiveSalary"] = userObject["isEffectiveSalary"];
        defaultValues["effectiveCompensations"] = deepClone(userObject["effectiveCompensations"]);
        defaultValues["benefits"] = userObject.benefits ? deepClone(userObject["benefits"]) : [];
        this.setEffectiveSalaryValues(defaultValues, userObject);
        defaultValues["inviteUserToFillInfo"] = userObject["inviteUserToFillInfo"];
        defaultValues["components"] = userObject.components ? deepClone(userObject["components"]): [];
        defaultValues["locationValue"] = userObject?.locationValue;
        defaultValues["ratePerHour"] = userObject?.ratePerHour;
        return defaultValues;
    }

    static getTranformedDate (date) {
        return moment(date).toDate();
    }  

    static getValueFromDropDown(item, options, key) {
        let value = [];
        if(item) {
            let index = options.findIndex(op => op[key] === item);
            value = index != -1 ? [index]: [];
        }
        return value;
    }

    static getValueFromMuliSelect(item, options, key) {
        let value = [];
        if(item && Array.isArray(item) && item.length > 0) {
            item.forEach(i => {
                let index = options.findIndex((op) => op[key] === i);
                if(index != -1) value.push(index);
            })
        }
        return value;
    }

    static getValueForMultiSelect(value, options, key) {
        let selectedOptions = [];
        if (value?.length > 0 && options?.length > 0) {
            value.forEach((i) => {
              let index = options.findIndex((op) => op[key] === i);
              selectedOptions.push(options[i][key]);
            });
        }
        return selectedOptions
    }

    static mapCompensationPeriodToDropdownId(compensationPeriod) {
        if (!compensationPeriod) {
            return compensationPeriod;
        }
        // Map backend values to dropdown IDs
        const periodMap = {
            "monthly": "30",
            "yearly": "365",
            "year": "365",
            "month": "30",
            "hourly": "hourly",
            "weekly": "weekly",
            "week": "weekly"
        };
        // Convert to lowercase for case-insensitive matching
        const lowerPeriod = compensationPeriod.toLowerCase();
        return periodMap[lowerPeriod] || compensationPeriod;
    }

    static mapDropdownIdToCompensationPeriod(dropdownId) {
        if (!dropdownId) {
            return dropdownId;
        }
        // Map dropdown IDs to backend values
        const periodMap = {
            "30": "monthly",
            "365": "yearly",
            "hourly": "hourly",
            "weekly": "weekly"
        };
        return periodMap[dropdownId] || dropdownId;
    }

    static getValueObjectFromDropdown (item, options, key) {
        let value = {};
        if(item && options) {
            let index = options.findIndex(op => op[key] === item);
            value = index != -1 ? options[index]: {};
        }
        return value;
    }

    static setPaymentFields(defaultValues, object, bankAccounts) {
        defaultValues["paymentMethod"]= this.getValueObjectFromDropdown(object["paymentMethod"],PaymentMethods, "id");
        let paymentMethod = object["paymentMethod"];
        if(paymentMethod === "directDeposit") {
            defaultValues["accountType"]= this.getValueObjectFromDropdown(object["accountType"],AccountTypes, "id");
            defaultValues["ifsc"]= object["ifsc"];
            defaultValues["accountNumber"]= object["accountNumber"];
            defaultValues["routingNumber"]= object["routingNumber"];
            defaultValues["bankId"] = object["bankId"];
            defaultValues["bank"]= this.getValueObjectFromDropdown(object["bank"],bankAccounts, "key")
        } else if(paymentMethod === "cheque") {
            defaultValues["accountNumber"]= object["accountNumber"];
        } else if(paymentMethod === "upi") {
            defaultValues["upiId"]= object["upi"];
            defaultValues["ifsc"]= object["ifsc"];
        }
    }
    static setAddressFields(defaultValues, object) {
        defaultValues["addressLine1"]= object["addressLine1"];
        defaultValues["addressLine2"]= object["addressLine2"];
        defaultValues["zipCode"]= object["zipCode"];
        defaultValues["city"]= object["city"];
        defaultValues["state"]= this.getValueFromDropDown(object["state"],IN_STATES, "code");
    }

    static setCustomFieldValues(defaultValues, userObject, customFields) {
        if(userObject["customFieldData"] && userObject["customFieldData"].length > 0) {
            userObject["customFieldData"].forEach(element => {
                let customField = customFields.filter(x=> x.id === element.customFieldId);
                if(customField && customField.length > 0) {
                    if(INPUT_FIELD_MAP[customField[0].type] === INPUT_TYPE.MULTI_SELECT) {
                        defaultValues[element.customFieldId] = element.value && element.value.map(r=> customField[0].possibleValues.findIndex(op => op === r));
                    } else if (INPUT_FIELD_MAP[customField[0].type] === INPUT_TYPE.DATE){
                        const date = moment(Utility.formatDate(element.value && element.value[0] ? element.value[0] : "")).toDate();
                        defaultValues[element.customFieldId] = Utility.isValidDate(date) ? reverseTimezoneOffset(date) : "";
                    }else {
                        defaultValues[element.customFieldId] = element.value && element.value[0] ? element.value[0] : "";
                    }
                }
            });
        }
    }

    static setEffectiveSalaryValues(defaultValues, userObject) {
        if(userObject.isEffectiveSalary) {
            const effectiveCompensations = userObject.effectiveCompensations;
            let effectiveSalaryObj = {};
            effectiveCompensations.forEach(element => {
              if(element.isVisible) {
                effectiveSalaryObj = element;
              }
            });
            defaultValues['effectiveDate'] = moment(effectiveSalaryObj['effectiveDate'], "YYYY-MM-DD").toDate();
            defaultValues['defaultCompensation'] = effectiveSalaryObj['compensation'];
            const mappedEffectivePeriod = this.mapCompensationPeriodToDropdownId(effectiveSalaryObj['period']);
            defaultValues['effectivePeriod'] = isUSCompliance() ? this.getValueObjectFromDropdown(mappedEffectivePeriod,CompensationPeriodUS, "id"): this.getValueObjectFromDropdown(mappedEffectivePeriod,CompensationPeriod, "id");
            defaultValues['effectiveDefaultHrs'] = effectiveSalaryObj['effectiveDefaultHrs']
        }
    }

    static createComplainceColumnConfig(employeeMeta, defaultValues, complianceData, inviteUserFlow, expandedState, externalOptions,hasPermission) {
        const isAdmin = TenantService.get(TENANT.IS_ADMIN);
        const columnConfig = [];
        if(employeeMeta && employeeMeta.sections && employeeMeta.sections.length > 0) {
            let index = 0;
            employeeMeta.sections.forEach(section => {
                let sectionGroup = {};
                expandedState[index] = !(
                  inviteUserFlow &&
                  (section.sectionNo === 1 || section.sectionNo === 2)
                );
                sectionGroup["title"] = section.title;
                sectionGroup["sectionNo"] = section.sectionNo;
                sectionGroup["defaultState"] = section.defaultState;
                sectionGroup["index"] = index++;
                if(section.fields && section.fields.length > 0) {
                    let fieldArray = []
                    section.fields.forEach(field => {
                        let fieldGroup = {};
                        fieldGroup['columnCode'] = field.fieldId;
                        fieldGroup['editable'] = field.editable;
                        fieldGroup['id'] = field.fieldId;
                        fieldGroup['index'] = field.sequenceNo;
                        fieldGroup['name'] = this.getFieldLabels(field.fieldId,field.fieldLabel);
                        fieldGroup["options"] = field.options
                          ? this.getFieldOptions(
                              field.fieldId,
                              field.options,
                              externalOptions
                            )
                          : [];
                        fieldGroup['defaultOptions'] = field.options;
                        fieldGroup["required"] = this.isRequired(
                          field.validators,
                          field.fieldId,
                          inviteUserFlow,
                          field.isMandatory
                        );
                        fieldGroup['systemField'] = true;
                        fieldGroup['type'] = INPUT_FIELD_MAP_COMPLIANCE[field.fieldType] ===
                        INPUT_TYPE.MULTI_SELECT
                          ? INPUT_FIELD_MAP_COMPLIANCE["dropdown"]
                          : INPUT_FIELD_MAP_COMPLIANCE[field.fieldType];

                        fieldGroup['uiVisible'] = field.hidden ? !field.hidden : true;
                        fieldGroup['width'] = this.getColumnWidth(field);
                        fieldGroup['subWidth'] = this.getSubWidth(field);
                        fieldGroup['direction'] = "VERTICAL";
                        fieldGroup['readOnly'] = 
                        // (
                            !isAdmin 
                            // && !hasPermission) 
                            && DataGridUtility.checkIsFieldReadOnly(field.fieldId, !field.editable);
                        fieldGroup['hasError'] = false;
                        fieldGroup['errMsg'] = `Enter a valid ${field.fieldLabel}`;
                        fieldGroup['hasTooltip'] = !Utility.isEmpty(field.tooltip) || !Utility.isEmpty(COMPLIANCE_TOOLTIP_FIELDS_MESSAGES[field.fieldId]);
                        fieldGroup['tooltipText'] = this.getTooltipTextForCompiance(field.fieldId,field.tooltip);
                        fieldGroup["validators"] = field.validators;
                        fieldGroup["maxLength"] = field.maxLength;
                        fieldGroup["minLength"] = field.minLength;
                        fieldGroup["conditionalHideShowField"] =
                          field.conditionalHideShowField;
                        fieldGroup["isMultiSelect"] = INPUT_FIELD_MAP_COMPLIANCE[field.fieldType] ===
                          INPUT_TYPE.MULTI_SELECT
                            ? true: false
                        fieldGroup['radioButtons'] = field.radioButtons;
                        this.getAddNewButtonConfig(fieldGroup);

                        if(INPUT_FIELD_MAP_COMPLIANCE[field.fieldType] === INPUT_TYPE.MULTI_SELECT) {
                            defaultValues[field.fieldId] = this.getValueFromDropDown(field.defaultValue, field.options, "id");
                        } else if(INPUT_FIELD_MAP_COMPLIANCE[field.fieldType] === INPUT_TYPE.DROPDOWN) {
                            defaultValues[field.fieldId] = this.getValueObjectFromDropdown(field.defaultValue, field.options, "id");
                        } else if(INPUT_FIELD_MAP_COMPLIANCE[field.fieldType] === INPUT_TYPE.NUMBER) {
                            defaultValues[field.fieldId] = field.defaultValue ? field.defaultValue : 0;
                        } else if(INPUT_FIELD_MAP_COMPLIANCE[field.fieldType] === INPUT_TYPE.RADIO_BUTTON) {
                            defaultValues[field.fieldId] = field.defaultValue ? field.defaultValue : (field.radioButtons.find(rf=>(rf.isDefault))?.fieldId );
                        } else {
                            defaultValues[field.fieldId] = field.defaultValue && field.defaultValue === "true" ? true : "";
                        }
                        if(complianceData) {
                            if (complianceData[field.fieldId] === null || complianceData[field.fieldId] === undefined || String(complianceData[field.fieldId]).length === 0) {
                                defaultValues[field.fieldId] = defaultValues[field.fieldId];
                            } else {
                                if(INPUT_FIELD_MAP_COMPLIANCE[field.fieldType] === INPUT_TYPE.MULTI_SELECT) {
                                    defaultValues[field.fieldId] = this.getValueFromMuliSelect(complianceData[field.fieldId], fieldGroup["options"], "id");
                                } else if(INPUT_FIELD_MAP_COMPLIANCE[field.fieldType] === INPUT_TYPE.DROPDOWN) {
                                    if (field.fieldId === "employeeQualification" && complianceData[field.fieldId] === "contributionNotAtFullRate") {
                                        fieldGroup["options"] = [{ id: 'contributionNotAtFullRate', name: 'Contribution Not At Full Rate' }];
                                        defaultValues[field.fieldId] = this.getValueObjectFromDropdown(complianceData[field.fieldId], fieldGroup["options"], "id");
                                    } else {
                                        defaultValues[field.fieldId] = this.getValueObjectFromDropdown(complianceData[field.fieldId], fieldGroup["options"], "id");
                                    }
                                } else if(INPUT_FIELD_MAP_COMPLIANCE[field.fieldType] === INPUT_TYPE.DATE) {
                                    defaultValues[field.fieldId] = moment(complianceData[field.fieldId], "YYYY-MM-DD").toDate()
                                } else if(INPUT_FIELD_MAP_COMPLIANCE[field.fieldType] === INPUT_TYPE.RADIO_BUTTON) {
                                    defaultValues[field.fieldId] = complianceData[field.fieldId] ? (typeof(complianceData[field.fieldId]) === "number" ? (complianceData[field.fieldId]).toString() : field.defaultValue) : field.defaultValue;
                                } else {
                                    defaultValues[field.fieldId] = getMaskedValue(complianceData[field.fieldId],field.fieldId);
                                }
                            }
                        }
                        fieldArray.push(fieldGroup)
                    });

                    sectionGroup["fields"] = fieldArray;
                }
                columnConfig.push(sectionGroup)
            });
        }
        return columnConfig;
    }

    static showHideFieldConfig(field, inviteUserFlow, externalOptions) {
        let fieldGroup = {};
        const isAdmin = TenantService.get(TENANT.IS_ADMIN);
        fieldGroup["columnCode"] = field.fieldId;
        fieldGroup["editable"] = field.editable;
        fieldGroup["id"] = field.fieldId;
        fieldGroup["index"] = field.sequenceNo;
        fieldGroup["name"] = this.getFieldLabels(
          field.fieldId,
          field.fieldLabel
        );
        fieldGroup["options"] = field.options
          ? this.getFieldOptions(field.fieldId, field.options, externalOptions)
          : [];
        fieldGroup["defaultOptions"] = field.options;
        fieldGroup["required"] = this.isRequired(
          field.validators,
          field.fieldId,
          inviteUserFlow,
          field.isMandatory
        );
        fieldGroup["systemField"] = true;
        fieldGroup["type"] =
          INPUT_FIELD_MAP_COMPLIANCE[field.fieldType] ===
          INPUT_TYPE.MULTI_SELECT
            ? INPUT_FIELD_MAP_COMPLIANCE["dropdown"]
            : INPUT_FIELD_MAP_COMPLIANCE[field.fieldType];

        fieldGroup["uiVisible"] = field.hidden ? !field.hidden : true;
        fieldGroup["width"] = this.getColumnWidth(field);
        fieldGroup["subWidth"] = this.getSubWidth(field);
        fieldGroup["direction"] = "VERTICAL";
        fieldGroup["readOnly"] =
          (!isAdmin &&
          DataGridUtility.checkIsFieldReadOnly(field.fieldId, !field.editable)) || field.readOnly;
        fieldGroup["hasError"] = false;
        fieldGroup["errMsg"] = `Enter a valid ${field.fieldLabel}`;
        fieldGroup["hasTooltip"] =
          !Utility.isEmpty(field.tooltip) ||
          !Utility.isEmpty(COMPLIANCE_TOOLTIP_FIELDS_MESSAGES[field.fieldId]);
        fieldGroup["tooltipText"] = this.getTooltipTextForCompiance(
          field.fieldId,
          field.tooltip
        );
        fieldGroup["validators"] = field.validators;
        fieldGroup["maxLength"] = field.maxLength;
        fieldGroup["minLength"] = field.minLength;
        fieldGroup["isMultiSelect"] =
          INPUT_FIELD_MAP_COMPLIANCE[field.fieldType] ===
          INPUT_TYPE.MULTI_SELECT
            ? true
            : false;
        fieldGroup['radioButtons'] = field.radioButtons;
        this.getAddNewButtonConfig(fieldGroup);
        return fieldGroup;
    }

    static getFieldOptions( fieldId, options, externalOptions) {
        switch (fieldId) {
          case COLUMN_CODES.PASSPORT_ISSUANCE_COUNTRY:
              let countryOptions = Countries.map((country) => {
                return {
                    id: country.code,
                    name: country.name
                }
            });
            return countryOptions;
            case COLUMN_CODES.NATIONALITY:
                return Nationalities;
            case COLUMN_CODES.COUNTRY_OF_ORIGIN:
                let countryOfOrigins = Countries.map((country) => {
                  return {
                    id: country.code,
                    name: country.name,
                  };
                });
                return countryOfOrigins;
            case COLUMN_CODES.ASSIGN_CPF_ACCOUNT:
                let cpfDetails = externalOptions?.CPFAccounts;
                if (cpfDetails?.accounts?.length > 0) {
                    let accounts = cpfDetails.accounts.map((account) => {
                        return {
                          id: account.accountId,
                          name: account?.compliance?.name,
                          accountType: account.accountType,
                          compliance: account.compliance,
                        };
                    });
                    accounts.splice(0, 0, {id: "clear_selection",name:"Clear Selection"})
                    return accounts;
                }
                return options;
        }
        return options;
    }

    static getAddNewButtonConfig(fielGroup) {
        switch (fielGroup.id) {
          case COLUMN_CODES.ASSIGN_CPF_ACCOUNT:
            fielGroup["buttonConfig"] = {
              title: "+ Add CPF Account",
              className: "bg-app text-white",
            };
            break;
        }
        return fielGroup;
      }    

    static getFieldLabels(fieldId, fieldLabel) {
        let updatedFieldLabel="";
        switch(fieldId) {
            case COLUMN_CODES.TAXES_APPLICABLE:
            case COLUMN_CODES.FOREIGN_INCOME_EARNED:
            case COLUMN_CODES.TAX_EXEMPT:
                updatedFieldLabel = COMPLIANCE_UPDATED_FIELDS[fieldId]
                break;
            default:
                updatedFieldLabel = fieldLabel
        }
        return updatedFieldLabel;
    }

    static getTooltipTextForCompiance(field, defaultText) {
        let text = "";
        switch(field) {
            case COLUMN_CODES.PF_ACCOUNT_NUMBER:
                text = `PF Account Number should have format (Example: AABBB11111112223333333)`
                break;
            case COLUMN_CODES.FEDERAL_FILING_STATUS:
            case COLUMN_CODES.SELECTED_STATE_INDICATOR:
            case COLUMN_CODES.TAXES_APPLICABLE:
            case COLUMN_CODES.STATUTORY_INDICATOR:
            case COLUMN_CODES.DEPENDENT_CLAIMS:
            case COLUMN_CODES.OTHER_INCOME:
            case COLUMN_CODES.DEDUCTIONS:
            case COLUMN_CODES.EXTRA_WITHHOLDINGS:
            case COLUMN_CODES.MULTIPLE_JOBS:
            case COLUMN_CODES.RESIDENT_COUNTRY:
            case COLUMN_CODES.ESI_NUMBER:
            case COLUMN_CODES.SSN:
            case COLUMN_CODES.EIS_CONTIRBUTION:
                text = COMPLIANCE_TOOLTIP_FIELDS_MESSAGES[field]
                break;
            default:
                text = defaultText;
        }
        return text;
    }

    static isRequired(validators, fieldId, inviteUserFlow, isMandatory) {
        let required = false;
        if(validators) {
            required =
              validators.some((x) => x === CONSTANTS.REQUIRED) || isMandatory;
            if (inviteUserFlow) {
                required = !US_ADMIN_COMPAINCE_FIELDS.some((x) => x === fieldId)
            }
        }
        return required;
    }

    static getColumnWidth(field) {
        let width = isMobileWebView() ? 100:50;
        switch(field.fieldId) {
            case "pfAccountNumber":
            width = 100;
        }
        return width;
    }

    static getSubWidth(field) {
        let width = 90;
        switch(field.fieldId) {
            case "pfAccountNumber":
            width = isMobileWebView() ? 100:43;
        }
        return width;
    }

    static createFixedComponentColumnConfig(fixedComponents, defaultValues, componentsData, remainingotions, remainingDefaultOptions, isEdit) {
        const isAdmin = TenantService.get(TENANT.IS_ADMIN);
        let fixedColumnConfig = [];
        if(componentsData && componentsData.length > 0) {
            if(!isEdit) {
                this.addDefaultComponentsinFixed(fixedComponents, componentsData);
            }
            componentsData.forEach(component => {
                let componentData = fixedComponents && fixedComponents.filter(x=> x.id === component.componentId);
                if(componentData && componentData.length > 0 && !fixedColumnConfig.some(x=> x.id === component.componentId)) {
                    let fieldGroup = {};
                    let index = 0;
                        fieldGroup['columnCode'] = component.componentId;
                        fieldGroup['editable'] = true;
                        fieldGroup['id'] = component.componentId;
                        fieldGroup['index'] = index++;
                        fieldGroup['name'] = component.name;
                        fieldGroup['componentName'] = component.name;
                        fieldGroup['isVariable'] = componentData[0].isVariable;
                        fieldGroup['defaultComponent'] = componentData[0].defaultComponent;
                        fieldGroup['componentType'] = component.type;
                        fieldGroup['options'] = deepClone(remainingotions);
                        fieldGroup['required'] = true;
                        fieldGroup['systemField'] = true;
                        fieldGroup['type'] = INPUT_TYPE.DROPDOWN;
                        fieldGroup['uiVisible'] = true;
                        fieldGroup['width'] = 40;
                        // fieldGroup['subWidth'] = this.getSubWidth(field);
                        fieldGroup['direction'] = "VERTICAL";
                        fieldGroup['readOnly'] = this.isReadOnlyField(componentData[0]) || !isAdmin;
                        fieldGroup['hasError'] = false;
                        fieldGroup['hasErrorAmount'] = false;
                        fieldGroup['errMsg'] = `Enter a valid ${component.name}`;
                        fieldGroup['hasTooltip'] = !Utility.isEmpty(component.tooltip);
                        fieldGroup['isEdit'] = this.isEditEnabled(componentData[0]);
                        fieldGroup['isDelete'] = this.isDeleteEnabled(componentData[0]);
                        fieldGroup['hasIconFrequency'] = this.isTooltipIcon(componentData[0]);
                        fieldGroup['tooltipText'] = "";
                        fieldGroup['defaultOptions'] = deepClone(remainingDefaultOptions);
                        fieldGroup['frequency'] = componentData[0].frequency;
                        fieldGroup['includeInCTC'] = componentData[0].includeInCTC;
                        fieldGroup['includeInOTCalc'] = componentData[0].includeInOTCalc;
                        fieldGroup['subType'] = componentData[0].subType;
                        let defaults = {};
                        let componentIndex = this.getComponentObjectIndex(component.componentId ,remainingotions, "id")
                        defaults["component"] = componentIndex != -1 ? remainingotions[componentIndex] : {};
                        defaults["amount"] = component.amount ? (component.amount).toFixed(2) : 0;
                        defaults["frequency"] = component.frequency && component.frequency.period ? this.getFrequency(component.frequency.period): "";
                        defaultValues[fieldGroup["id"]] = defaults;
                        fixedColumnConfig.push(fieldGroup);
                        remainingotions.splice(componentIndex, 1);
                        remainingDefaultOptions.splice(componentIndex, 1);
                }
            });
            fixedColumnConfig.forEach(item => {
                let selectedComponent = defaultValues[item["id"]]["component"];
                let unselectedOptions = deepClone(remainingotions);
                let unselectedDefaultOptions = deepClone(remainingDefaultOptions);
                let element = item["options"].find(x=> x.id === selectedComponent["id"]);
                let element01 = item["defaultOptions"].find(x=> x.id === selectedComponent["id"]);
                unselectedOptions.push(element);
                item["options"]= unselectedOptions;
                unselectedDefaultOptions.push(element01);
                item["defaultOptions"] = unselectedDefaultOptions;
                let componentIndex = this.getComponentObjectIndex(item.id ,item["options"], "id")
                defaultValues[item["id"]]["component"] = componentIndex != -1 ? item["options"][componentIndex] : {};
            });
        }
        return fixedColumnConfig

    }

    static isReadOnlyField(componentsData) {
        let isReadOnly = false;
        if(componentsData && componentsData.defaultComponent && (componentsData.name === CONSTANTS.FIXED_ALLOWANCE || componentsData.name === CONSTANTS.CONVEYANCE_ALLOWANCE || componentsData.name === CONSTANTS.BASIC || componentsData.name === CONSTANTS.HRA)) {
            isReadOnly = true;
        }
        return isReadOnly;
    }

    static isEditEnabled(componentsData) {
        let isEdit = true;
        if(componentsData && componentsData.defaultComponent && (componentsData.name === CONSTANTS.FIXED_ALLOWANCE || componentsData.name === CONSTANTS.CONVEYANCE_ALLOWANCE || componentsData.name === CONSTANTS.BASIC || componentsData.name === CONSTANTS.HRA)) {
            isEdit = false;
        }
        return isEdit;
    }

    static isDeleteEnabled(componentsData) {
        let isDelete = true;
        if(componentsData && componentsData.defaultComponent && (componentsData.name === CONSTANTS.FIXED_ALLOWANCE || componentsData.name === CONSTANTS.CONVEYANCE_ALLOWANCE || componentsData.name === CONSTANTS.BASIC || componentsData.name === CONSTANTS.HRA)) {
            isDelete = false;
        }
        return isDelete;
    }

    static isTooltipIcon(componentsData) {
        let isIcon = false;
        if(componentsData && componentsData.frequency && componentsData.frequency.period != "everyPayrun") {
            isIcon = true;
        }
        return isIcon;
    }

    static getFrequency(frequency) {
        let value = "";
        let frequencyList = COMPONENT_FREQUENCY_TYPE_LIST.filter(x=> x.id === frequency);
        if(frequencyList && frequencyList.length > 0) {
            value = frequencyList[0].name;
        }
        return value
    }

    static getComponentsOptions(fixedComponents, dropDownOptions, defaultOptions) {
        fixedComponents.filter(x=> x.isActive).map(x=> {
                defaultOptions.push(x);
                dropDownOptions.push(x.name)
        })

        return dropDownOptions;
    }

    static getComponentIndex(name, options) {
        return options.indexOf(name);
    }

    static getComponentObjectIndex(componentId, options, key) {
        let index = options.findIndex(x=> ( x && x[key] === componentId));
        return index;
    }

    static getInitalOptions(components, options, defaultOptions,remainingOptions,remainingDefaultOptions) {
        options?.splice(0, options.length);
        defaultOptions?.splice(0, defaultOptions.length);
        remainingDefaultOptions?.splice(0, remainingDefaultOptions.length);
        remainingOptions?.splice(0, remainingOptions.length);
    }
    static getFixedDropDownOptions(components, options, defaultOptions,remainingOptions,remainingDefaultOptions) {
        components && components.filter(x=> x.isActive).map(x=> {
                defaultOptions.push(x);
                remainingDefaultOptions.push(x);
                options.push(x)
                remainingOptions.push(x);
        });
    }

    static createVariableComponentColumnConfig(variableComponents, defaultValues, componentsData, remainingotions, remainingDefaultOptions, isEdit) {
        const isAdmin = TenantService.get(TENANT.IS_ADMIN);
        let variableColumnConfig = [];
        if(componentsData && componentsData.length > 0) {
            if(!isEdit) {
                this.addDefaultComponentsinVariable(variableComponents, componentsData)
            }
            componentsData.forEach(component => {
                let componentData = variableComponents && variableComponents.filter(x=> x.id === component.componentId);
                if(componentData && componentData.length > 0 && !variableColumnConfig.some(x=> x.id === component.componentId)) {
                    let fieldGroup = {};
                    let index = 0;
                    fieldGroup['columnCode'] = component.componentId;
                    fieldGroup['editable'] = true;
                    fieldGroup['id'] = component.componentId;
                    fieldGroup['defaultComponent'] = componentData[0].defaultComponent;
                    fieldGroup['index'] = index++;
                    fieldGroup['name'] = component.name;
                    fieldGroup['isVariable'] = componentData[0].isVariable;
                    fieldGroup['componentName'] = component.name;
                    fieldGroup['defaultComponent'] = componentData[0].defaultComponent;
                    fieldGroup['variableName'] = this.getVariableFieldName(component);
                    fieldGroup['isPercent'] = this.isPercentageConfigured(component);
                    fieldGroup['componentType'] = component.type;
                    fieldGroup['options'] = deepClone(remainingotions);
                    fieldGroup['required'] = true;
                    fieldGroup['systemField'] = true;
                    fieldGroup['type'] = INPUT_TYPE.DROPDOWN;
                    fieldGroup['uiVisible'] = true;
                    fieldGroup['width'] = 40;
                    fieldGroup['direction'] = "VERTICAL";
                    fieldGroup['readOnly'] = this.isReadOnlyField(componentData[0]) || !isAdmin;
                    fieldGroup['hasError'] = false;
                    fieldGroup['hasErrorVariable'] = false;
                    fieldGroup['errMsg'] = `Enter a valid ${component.name}`;
                    fieldGroup['errMsgVariable'] = ERRORS_COMPONENTS.VARIABLE;
                    fieldGroup['hasTooltip'] = !Utility.isEmpty(component.tooltip);
                    fieldGroup['isEdit'] = this.isEditEnabled(componentData[0]);
                    fieldGroup['isDelete'] = this.isDeleteEnabled(componentData[0]);
                    fieldGroup['hasIconFrequency'] = this.isTooltipIcon(componentData[0]);
                    fieldGroup['tooltipText'] = "";
                    fieldGroup['defaultOptions'] = deepClone(remainingDefaultOptions);
                    fieldGroup['frequency'] = componentData[0].frequency;
                    fieldGroup['componentConfig'] = componentData[0].componentConfig;
                    fieldGroup['includeInCTC'] = componentData[0].includeInCTC;
                    fieldGroup['includeInOTCalc'] = componentData[0].includeInOTCalc;
                    fieldGroup['subType'] = componentData[0].subType;
                    fieldGroup['hasInfo'] = this.hasInfoIcon(componentData[0]);
                    fieldGroup['hasInfoText'] = `Entered percentage value has been restricted to ${fieldGroup['subType'] === "basic_salary" ?  CONSTANTS.BASIC_THRESHOLD : CONSTANTS.HRA_THRESHOLD}%`;
                    let defaults = {};
                    let componentIndex = this.getComponentObjectIndex(component.componentId ,remainingotions, "id")
                    const componentMetaRow = componentData[0];
                    defaults["component"] = componentIndex != -1 ? remainingotions[componentIndex] : componentMetaRow;
                    defaults["amount"] = component.amount ? (component.amount).toFixed(2) : 0;
                    defaults["frequency"] = component.frequency && component.frequency.period ? this.getFrequency(component.frequency.period): "";
                    defaults["variableValue"] = component && component.componentConfig ? this.getVariableValue(fieldGroup["isPercent"], component) : 0;
                    defaultValues[fieldGroup["id"]] = defaults;
                    variableColumnConfig.push(fieldGroup);
                    if (componentIndex !== -1) {
                        remainingotions.splice(componentIndex, 1);
                        remainingDefaultOptions.splice(componentIndex, 1);
                    }
                }
            });
            variableColumnConfig.forEach(item => {
                let selectedComponent = defaultValues[item["id"]]["component"];
                if (!selectedComponent || Utility.isEmpty(selectedComponent) || selectedComponent["id"] == null) {
                    return;
                }
                let unselectedOptions = deepClone(remainingotions);
                let unselectedDefaultOptions = deepClone(remainingDefaultOptions);
                let element = item["options"].find(x=> x && x.id === selectedComponent["id"]);
                let element01 = item["defaultOptions"].find(x=> x && x.id === selectedComponent["id"]);
                if (element) unselectedOptions.push(element);
                item["options"]= unselectedOptions;
                if (element01) unselectedDefaultOptions.push(element01);
                item["defaultOptions"] = unselectedDefaultOptions;
                let componentIndex = this.getComponentObjectIndex(item.id ,item["options"], "id")
                defaultValues[item["id"]]["component"] = componentIndex != -1 ? item["options"][componentIndex] : {};
            });
        }
        return variableColumnConfig
    }

    static hasInfoIcon(componentsData) {
        let hasIcon = false;
        if(componentsData && componentsData.defaultComponent && (componentsData.name === CONSTANTS.BASIC || componentsData.name === CONSTANTS.HRA)) {
            hasIcon = true;
        }
        return hasIcon;
    }

    static getVariableFieldName(component) {
        let name = "";
        if(component && component.componentConfig && component.componentConfig.configureAmountBasis) {
            const configureValue = component.componentConfig.configureAmountBasis;
            let fieldJson = IN_CONFIGURE_AMOUNT_BASED_ON.filter(x=> x.id === configureValue);
            if(fieldJson && fieldJson.length > 0) {
                name = fieldJson[0].name;
            }
        }
        return name;

    }

    static isPercentageConfigured(component) {
        let isPercent = true;
        if(component && component.componentConfig && component.componentConfig.configureAmountBasis) {
            const configureValue = component.componentConfig.configureAmountBasis;
            if(configureValue && configureValue === CONSTANTS.AMOUNT_PER_DAY) {
                isPercent = false;
            }
        }
        return isPercent;
    }

    static isReadOnlyFieldForVariable(componentsData) {
        let isReadOnly = false;
        if(componentsData && componentsData.defaultComponent && (componentsData.name === CONSTANTS.BASIC || componentsData.name === CONSTANTS.HRA)) {
            isReadOnly = true;
        }
        return isReadOnly;
    }

    static getVariableValue(isPercent, component) {
        let value = 0;
        if(isPercent) {
            value = component.componentConfig.componentPercent;
        } else {
        value = component.componentConfig.amountPerDay;
        }
        return value;
    }

    static addDefaultComponentsinFixed(fixedComponents, componentsData) {
        let defaultFixedComponents = fixedComponents.filter(x => x.defaultComponent);
        if(defaultFixedComponents && defaultFixedComponents.length > 0) {
            defaultFixedComponents.forEach(component => {
                let isPresent = componentsData.some(x=> x.componentId === component.id);
                if(!isPresent) {
                    let columnConfig = {};
                    columnConfig["amount"] = 0;
                    columnConfig["componentId"] = component.id;
                    columnConfig["componentConfig"] = component.componentConfig;
                    columnConfig["frequency"] = component.frequency;
                    columnConfig["name"] = component.name;
                    columnConfig["status"] = "";
                    columnConfig["subType"] = component.subType;
                    columnConfig["type"] = component.type;
                    componentsData.push(columnConfig);
                }
            });

        }

    }

    static addDefaultComponentsinVariable(variableComponents, componentsData) {
        let defaultVariableComponents = variableComponents.filter(x => x.defaultComponent);
        if(defaultVariableComponents && defaultVariableComponents.length > 0) {
            defaultVariableComponents.forEach(component => {
                let isPresent = componentsData.some(x=> x.componentId === component.id);
                if(!isPresent) {
                    let columnConfig = {};
                    columnConfig["amount"] = 0;
                    columnConfig["componentId"] = component.id;
                    columnConfig["componentConfig"] = component.componentConfig;
                    columnConfig["frequency"] = component.frequency;
                    columnConfig["name"] = component.name;
                    columnConfig["status"] = "";
                    columnConfig["subType"] = component.subType;
                    columnConfig["type"] = component.type;
                    componentsData.push(columnConfig);
                }
            });

        }

    }

    static createBenefitComponentColumnConfig(benefitComponents, defaultValues, componentsData, remainingotions, remainingDefaultOptions, isEdit) {
        const isAdmin = TenantService.get(TENANT.IS_ADMIN);
        let benefitColumnConfig = [];
        // this.getComponentsOptions(fixedComponents, dropDownOptions, defaultDropdownoptions);
        if(componentsData && componentsData.length > 0) {
            if(!isEdit) {
                this.addDefaultComponentsinFixed(benefitComponents, componentsData);
            }
            componentsData.forEach(component => {
                let componentData = benefitComponents.filter(x=> x.id === component.componentId);
                if(componentData && componentData.length > 0 && !benefitColumnConfig.some(x=> x.id === component.componentId)) {
                    let fieldGroup = {};
                    let index = 0;
                        fieldGroup['columnCode'] = component.benefitId;
                        fieldGroup['editable'] = true;
                        fieldGroup['id'] = component.benefitId;
                        fieldGroup['index'] = index++;
                        fieldGroup['name'] = component.name;
                        fieldGroup['componentName'] = component.name;
                        fieldGroup['employeeDeductionType'] = component.employeeDeductionType;
                        fieldGroup['employerDeductionType'] = component.employerDeductionType;
                        fieldGroup["componentType"] = "BENEFIT";
                        fieldGroup['options'] = deepClone(remainingotions);
                        fieldGroup['required'] = true;
                        fieldGroup['systemField'] = true;
                        fieldGroup['type'] = INPUT_TYPE.DROPDOWN;
                        fieldGroup['uiVisible'] = true;
                        fieldGroup['width'] = 40;
                        fieldGroup['direction'] = "VERTICAL";
                        fieldGroup['readonly'] = !isAdmin;
                        fieldGroup['hasError'] = false;
                        fieldGroup['hasErrorEmployeeAmount'] = false;
                        fieldGroup['hasErrorEmployerAmount'] = false;
                        fieldGroup['errMsg'] = `Enter a valid ${component.name}`;
                        fieldGroup['hasTooltip'] = !Utility.isEmpty(component.tooltip);
                        fieldGroup['isEdit'] = this.isEditEnabled(componentData[0]);
                        fieldGroup['isDelete'] = this.isDeleteEnabled(componentData[0]);
                        fieldGroup['defaultOptions'] = deepClone(remainingDefaultOptions);
                        fieldGroup['isForAllEmployees'] = componentData[0].isForAllEmployees;
                        fieldGroup['users'] = componentData[0].users;
                        let defaults = {};
                        let componentIndex = this.getComponentObjectIndex(component.benefitId ,remainingotions, "benefitId")
                        defaults["component"] = componentIndex != -1 ? remainingotions[componentIndex] : [];
                        defaults["employeeDeductionAmount"] = component.employeeDeductionAmount ? (component.employeeDeductionAmount).toFixed(2) : 0;
                        defaults["employerDeductionAmount"] = component.employerDeductionAmount ? (component.employerDeductionAmount).toFixed(2) : 0;
                        defaults["employeeDeductionType"] = component.employeeDeductionType ? component.employeeDeductionType: "";
                        defaults["employerDeductionType"] = component.employerDeductionType ? component.employerDeductionType: "";
                        defaultValues[fieldGroup["id"]] = defaults;
                        benefitColumnConfig.push(fieldGroup);
                        remainingotions.splice(componentIndex, 1);
                        remainingDefaultOptions.splice(componentIndex, 1);
                }
            });
            benefitColumnConfig.forEach(item => {
                let selectedComponent = defaultValues[item["id"]]["component"];
                let unselectedOptions = deepClone(remainingotions);
                let unselectedDefaultOptions = deepClone(remainingDefaultOptions);
                let element = item["options"].find(x=> x.benefitId === selectedComponent["benefitId"]);
                let element01 = item["defaultOptions"].find(x=> x.benefitId === selectedComponent["benefitId"]);
                unselectedOptions.push(element);
                item["options"]= unselectedOptions;
                unselectedDefaultOptions.push(element01);
                item["defaultOptions"] = unselectedDefaultOptions;
                let componentIndex = this.getComponentObjectIndex(item.id ,item["options"], "benefitId")
                defaultValues[item["id"]]["component"] = componentIndex != -1 ? item["options"][componentIndex] : [];
            });
        }
        return benefitColumnConfig

    }

    static assignContractorDetails(defaultValues, userObject, bankAccounts) {
        defaultValues["contractorType"]= userObject["contractorType"];
        defaultValues["title"]= userObject["title"];
        defaultValues["firstName"]= userObject["firstName"];
        defaultValues["middleName"]= userObject["middleName"];
        defaultValues["lastName"]= userObject["lastName"];
        defaultValues["displayName"]= userObject["displayName"];
        defaultValues["employerIdentificationNumber"]= this.formatInputValue(userObject["employerIdentificationNumber"], "EIN");
        defaultValues["socialSecurityNumber"]= this.formatInputValue(userObject["socialSecurityNumber"], "SSN");
        defaultValues["emailId"]= userObject["emailId"];
        defaultValues["compensationPeriod"]= userObject["compensationPeriod"];
        defaultValues["compensation"]= userObject["compensation"];
        this.setPaymentFields(defaultValues, userObject["paymentDetails"],  bankAccounts);
        return defaultValues;
    }

    static formatInputValue (inputValue, fieldId) {
        let value = "";
        if(!Utility.isEmpty(inputValue)) {
            switch(fieldId) {
                case "EIN" :
                    if(inputValue.length === 9) {
                        value = `${inputValue.substring(0,2)}-${inputValue.substring(2)}`
                    }
                    break;
                case "SSN":
                    if(inputValue.length === 9) {
                        value = `${inputValue.substring(0,3)}-${inputValue.substring(3,5)}-${inputValue.substring(5)}`
                    }
                    break
            }
        }
        return value;

    }

    static unFormatValue (inputValue, fieldId) {
        let formatValue = "";
        switch(fieldId) {
            case  "EIN":
                formatValue = inputValue.replace(/-/g,'')
                break;
            case "SSN" :
                formatValue = inputValue.replace(/-/g,'')
                break
        }
        return formatValue
    }


    static getContactNumber(countryCode, contact) {
        switch(countryCode) {
            case "IN":
                contact = `+91${contact}`;
                break;
            case "SG":
                contact = `+65${contact}`;
                break;
            case "MY":
                contact = `+60${contact}`;
                break;
            default:
                contact = `+91${contact}`;
        }
        return contact;
    }

    static getSelectedIdFromObject = (value, key) => {
    let selectedId = "";
    if (!Utility.isEmpty(value) && typeof value === "object") {
      selectedId = value[key];
    }
    return selectedId;
  }


    static getAlteredConfigDetails (formFields, alteredFields, isDefaultUpdate, defaultValues, updatedValues) {
        alteredFields.forEach(fields => {
            let index = formFields.findIndex(f => f.columnCode === fields.columnCode);
            if(index != -1) {
                formFields[index] = { ...formFields[index], ...fields };
                if (isDefaultUpdate && updatedValues[fields.columnCode]) {
                  defaultValues[fields.columnCode] =
                    updatedValues[fields.columnCode];
                }
            }
        });
        return formFields;
    }

    static getBankAccounts(details) {
        let bankAccounts = [];
        if (details?.banksDetails?.length > 0) {
            details.banksDetails.forEach((element) => {
              element = { ...element, name: element.bank };
              bankAccounts.push(element);
            });
        }
        return bankAccounts;
    }


  static getAlteredSectionConfigDetails (formFields, alteredFields, innerFieldName, sectionIndex) {
    alteredFields.forEach(fields => {
        let index = formFields[sectionIndex][innerFieldName]?.findIndex(f => f.columnCode === fields.columnCode);
        if(index != -1) {
            formFields[sectionIndex][innerFieldName][index] = { ...formFields[sectionIndex][innerFieldName][index], ...fields };
        }
    });
    return formFields;
  }

  static getAlteredFormConfig(formFields, alteredFields) {
    alteredFields.forEach(a => {
        const iIndex = formFields[a.fieldColumnCode].section[a.sectionColumnCode]?.fields.findIndex(f => f.columnCode === a?.fieldConfig?.columnCode );
        if(iIndex != -1) {
            formFields[a.fieldColumnCode].section[a.sectionColumnCode].fields[iIndex] = deepClone({...formFields[a.fieldColumnCode].section[a.sectionColumnCode].fields[iIndex], ...a.fieldConfig});
        }
    });
    return formFields;
  }

  static updateCustomFieldValuesForEmployee(values, customFieldsData, group) {
    const { customFields } = customFieldsData || [];
    const customFieldFormValues = values?.customFieldData || [];
    customFields?.forEach((c) => {
        const formValues = customFieldFormValues.find((x) => x.customFieldId === c.id);
        if(!Utility.isEmptyObject(formValues)) {
            switch (c.type) {
                case "text":
                    if(formValues?.value) {
                        group[c.id] = formValues?.value[0];
                    }
                    break;
                case "multiselect":
                    group[c.id] = formValues?.value;
                    break;
            
                default:
                    if(formValues?.value) {
                        group[c.id] = formValues?.value[0];
                    }
                    break;
            }
        }
    });
    return group;
  }

    static getUsersShortInfo(params) {
        return http.get(`${ApiConstants.URL.PEOPLE.USER_SHORT_INFO}`, { params: params })
        .catch((err: any) => {
            console.error('Error fetching users short info: ', err);
            return Promise.reject(err);
        });
    }

    static getEmployeeSalaryHistory(userId, params) {
        const url = `${ApiConstants.URL.BASE + ApiConstants.URL.PEOPLE.USERS}/employee-update-history/${userId}`
        return http.get(`${url}`,
            {
                params: {
                    limit: params.limit,
                    currentPage: params.currentPage,
                    fromDate: params.fromDate,
                    toDate: params.tDate,
                    order: params.order,
                    field: params.field,
                }
            });
    }

    static getAddEmployeeConfig() {
        const payload = {
			configNames: ["EMPLOYEE_CONFIG"]
		};

        return http.post(`${ApiConstants.URL.EMPLOYEE.FIELD_CONFIG}`, payload)
        .catch((err: any) => {
            console.error('Error fetching add employee config: ', err);
            return Promise.reject(err);
        });
    }

    static getFieldPermissions() {
        return http.get(`${ApiConstants.URL.EMPLOYEE.FIELD_PERMISSIONS}`)
        .catch((err: any) => {
            console.error('Error fetching role field permissions: ', err);
            return Promise.reject(err);
        });
    }

    static getRolePermissions() {
        return http.get(`${ApiConstants.URL.EMPLOYEE.ROLE_PERMISSIONS}`).catch((err: any) => {
            console.error('Error fetching role permissions: ', err);
            return Promise.reject(err);
        });
    }

    static getPeopleUsersShortInfo() {
        return http.post(`${ApiConstants.URL.EMPLOYEE.SHORT_INFO}`)
        .catch((err: any) => {
            console.error('Error fetching people users short info: ', err);
            return Promise.reject(err);
        });
    }
}

export default EmployeeListService;
